export default function CheckShieldIcon({ width = 24, height = 24, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M19.5 3.75h-15A1.5 1.5 0 0 0 3 5.25v5.51c0 8.4 7.108 11.188 8.531 11.661.304.104.634.104.938 0C13.894 21.948 21 19.161 21 10.76V5.25a1.5 1.5 0 0 0-1.5-1.5Zm-3.22 6.53-5.25 5.25a.747.747 0 0 1-1.06 0l-2.25-2.25a.75.75 0 1 1 1.06-1.06l1.72 1.719 4.72-4.72a.751.751 0 0 1 1.06 1.062Z"
      />
    </svg>
  );
}
